import { useEffect } from "react";
import { SITE } from "./config";
import data from "./pages.json";

type Meta = { path: string; title: string; description: string };

const PAGES: Meta[] = data.pages;

export function pageMeta(path: string): Meta {
  const m = PAGES.find((p) => p.path === path);
  if (!m) throw new Error(`no entry for ${path} in src/pages.json`);
  return m;
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

/**
 * Sets the title, description, canonical URL and the Open Graph / Twitter
 * title, description and URL for the current page. index.html carries the
 * landing page's values for crawlers that don't run JavaScript.
 */
export function useMeta({ path, title, description }: Meta) {
  useEffect(() => {
    const url = SITE.url + (path === "/" ? "/" : path);
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [path, title, description]);
}

/** useMeta for a page listed in src/pages.json. */
export function usePageMeta(path: string) {
  useMeta(pageMeta(path));
}
